<script lang="ts">
	import { ErrorReportIcon } from "luxedo-comps"
	import { HELP_LINK } from "luxedo-data"

	interface Props {
		errorMessage: string
		linkToSupport?: boolean
	}

	let { errorMessage, linkToSupport = true }: Props = $props()
</script>

<div class="error-container">
	<ErrorReportIcon />
	<p class="error-info">
		{errorMessage}
		{#if linkToSupport}
			If this persists,
			<a href={HELP_LINK} target="_blank">contact support</a>.
		{/if}
	</p>
</div>

<style>
	.error-container {
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 01rem;
	}

	.error-info {
		max-width: 24rem;
		text-align: center;
		color: var(--color-error);
	}

	a {
		color: var(--color-main);
		border: none;
	}
</style>
